export default "__VITE_ASSET__Ct_kZB21__"